export { default } from "./DoctorSetupForm.gql";
